module.exports = {"data":{"site":{"siteMetadata":{"title":"@fibasile blog","hero":{"title":"How to code (almost) anything","subtitle":"A blog about software, hardware and everything in between"}}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 95
// module chunks = 60335399758886 114276838955818